var _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_35_64",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 18,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H24V23H6V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_35_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.538147 -1.28571H29.7553V37.8834H-0.538147V-1.28571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.538147 -1.28571H29.7553V30.0496H-0.538147V-1.28571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.538147 -1.28571H29.7553V30.0496H-0.538147V-1.28571Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_35_64",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V30H0V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_35_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9848 -0.0101318C6.70531 -0.0101318 -0.0101318 6.70531 -0.0101318 14.9848C-0.0101318 23.2694 6.70531 29.9798 14.9848 29.9798C23.2694 29.9798 29.9798 23.2694 29.9798 14.9848C29.9798 6.70531 23.2694 -0.0101318 14.9848 -0.0101318ZM19.556 16.004C19.4803 16.0746 19.4046 16.1352 19.3188 16.1907L13.6932 21.8163C13.4157 22.0938 13.0575 22.23 12.6993 22.23C12.341 22.23 11.9828 22.0938 11.7104 21.8163C11.1654 21.2714 11.1654 20.3834 11.7104 19.8385L16.559 14.9899L11.7356 10.1614C11.1907 9.61651 11.1907 8.72852 11.7356 8.18361C12.2805 7.63871 13.1685 7.63871 13.7134 8.18361L19.3188 13.784C19.4046 13.8395 19.4803 13.9001 19.556 13.9757C19.8335 14.2532 19.9697 14.6216 19.9646 14.9899C19.9697 15.3531 19.8335 15.7215 19.556 16.004Z",
    fill: "#FEFEFE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/iconArrowRight.ab17d2ae.svg";
export { ForwardRef as ReactComponent };